import FormInputValidationMessage from "../components/forminputvalidationmessage";

const SmartField = ({label,defaultOption = label,name,register,errors,options,type = 'text',...props}) => {
    const error = errors?.[name];

    if(type === 'checkbox'){
        return(
            <label>
                <input type="checkbox" {...register(name)} {...props} />
                {label}
            </label>
        )
    }

    return(
        <>
            <label htmlFor={name}>{label}</label>
            {
                type === 'select' ? 
                    <select id={name} {...register(name)}  {...props}>
                        <option value=''>{defaultOption !== label ? `${defaultOption}` : `--Select ${label}--`}</option>
                        {options?.map(option => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </select>
                : 
                    type === 'textarea'
                    ?
                        <textarea id={name} rows={4}  {...register(name)} {...props}/>
                    :
                        <input id={name} type={type} {...register(name)}  {...props}/>
            }
            <FormInputValidationMessage error={error} />
        </>
    )
}

export default SmartField;